import { render, staticRenderFns } from "./SidebarRail.vue?vue&type=template&id=63974ac2"
import script from "./SidebarRail.vue?vue&type=script&lang=ts"
export * from "./SidebarRail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports